// extracted by mini-css-extract-plugin
export var calculatedBadge = "_x2-8";
export var container = "_x2-0";
export var radioDot = "_x2-5";
export var radioDotSelected = "_x2-6";
export var row = "_x2-1";
export var rowFirst = "_x2-2";
export var rowLast = "_x2-3";
export var rowSelected = "_x2-4";
export var strikethrough = "_x2-7";